import reducer from 'state/mrDistribution/shipments/reducer';
import selectors from 'state/mrDistribution/shipments/selectors';
import actions from 'state/mrDistribution/shipments/actionCreators';
import effects from 'state/mrDistribution/shipments/effects';

export { selectors, actions, effects };
export default reducer;
